import { InstanceErrorLOFactory } from "./../../../externalLogging/factories/InstanceErrorLOFactory";
import { ExternalLog } from "./../../../externalLogging/ExternalLog";
import { CommandController } from "./../../../commanding/CommandController";
import { SimpleCommand } from "./../../../commanding/SimpleCommand";
import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { BasicController } from "../BasicController";
import { BasicModel } from "../../model/BasicModel";
import { NetworkInstance, WorldAssignment } from "@goodgamestudios/world-assignment";
import { SmartfoxEvent } from "../../event/SmartfoxEvent";
import { BasicSmartfoxClient } from "../../model/components/BasicSmartfoxClient";
import { getLogger } from "@goodgamestudios/logger";
import { shouldReloadBranch } from "../../model/instance/BranchesModel";
const logger = getLogger("BasicConnectToInstanceVOCommand")
export class BasicConnectToInstanceVOCommand extends SimpleCommand {
    public static NAME: string = "BasicConnectToInstanceVOCommand";


    /*final*/
    public execute(instance: NetworkInstance): void {
        if (!instance) {
            logger.error("trying to connect to an instance without passing an instance ??");
            ExternalLog.logger.log(new InstanceErrorLOFactory(InstanceErrorLOFactory.CONNECT_TO_INSTANCE_NULL));
            return;
        }

        logger.debug("Going to connect to instance: " + instance.instanceId);
        if (shouldReloadBranch(instance)) {
            logger.warn("Reloading game because new instance is on a different branch")
            CommandController.instance.executeCommand(BasicController.COMMAND_RELOAD_PAGE_WITH_ZONE_ID, instance);
        }

        else {
            // TODO HTML5 CHECK THE FOLLOWING..     THIS COMMAND EXIST ONLY IN ORDER TO SET THE LISTENER AND THEN SAVEINSTANCE ON LOCAL DATA..   do we even need it?  cant we saveInstance on Local data directly inside BasicController.COMMAND_CONNECT_CLIENT?
            //  after refactor for HTML-4220 WorldAssignment is arleady updated and  InstanceProxy point directly to it-   should not be used and it is already updated with the

            if (!BasicModel.smartfoxClient) {
                BasicModel.smartfoxClient = new BasicSmartfoxClient();
            }
            else {
                BasicModel.smartfoxClient.removeEventListener(SmartfoxEvent.CONNECT_SUCCESS, this.bindFunction(this.onConnectionEstablished));
                BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.CONNECT_SUCCESS, this.bindFunction(this.onConnectionEstablished));
            }


            const worldAssignment = (window.ggs.worldAssignment as WorldAssignment);
            if (instance.instanceId != worldAssignment.facade.selectedNetworkInstance.instanceId) {
                worldAssignment.selectInstance(instance)
            }


            // If no maintenance executes BasicController.COMMAND_CONNECT_CLIENT
            CommandController.instance.executeCommand(BasicController.COMMAND_CHECK_MAINTENANCE, BasicController.COMMAND_CONNECT_CLIENT);
        }
    }

    protected onConnectionEstablished(event: SmartfoxEvent): void {
        if (BasicModel.localData) {
            // Don't save the instance in SharedObject for support key sessions
            if (EnvGlobalsHandler.globals.suk == "") {
                BasicModel.localData.saveInstance(BasicModel.instanceProxy.selectedInstanceVO.instanceId, BasicModel.instanceProxy.selectedInstanceVO.zoneId);
            }
        }
        BasicModel.smartfoxClient.removeEventListener(SmartfoxEvent.CONNECT_SUCCESS, this.bindFunction(this.onConnectionEstablished));
    }
}

